import warning from 'warning';
import deepmerge from 'deepmerge';
import zIndex from '@/uptk/core/packages/theme/z_index';
import createTheme from '@/uptk/core/packages/theme/createTheme';
import { createPalette, palettes } from '@/uptk/core/packages/theme/palette';
import { createShadows } from '@/uptk/core/packages/theme/shadows';
import { createTypography } from '@/uptk/core/packages/theme/typography';
import createToolkitThemeNext from '@/uptk/core/packages/theme/createToolkitThemeNext';

const overridesByComponentName = {
  MuiIconButton: {
    root: {
      padding: 0
    }
  }
};

type ToolkitThemeOptions = Record<string, any>;

const createToolkitTheme = (
  type: any,
  env?: any,
  envTheme?: any,
  options: ToolkitThemeOptions = {}
) => {
  /****
   if (env != 'prod') {
     warning(
         Object.prototype.hasOwnProperty.call(palettes, type),
         `UI-Toolkit: the palette type \`${type}\` is not supported.`
     );
   }
  ***/


   if (type != 'light' && type != 'dark') {
     warning(
         Object.prototype.hasOwnProperty.call(palettes, type),
         `UI-Toolkit: the palette type \`${type}\` is not supported.`
     );
   }

   const {
     palette: paletteOption = {},
     shadows: shadowOption = createShadows(type),
     typography: typographyOption = createTypography(),
     unstable_toolkit = {
       useNextDensity: false,
       useNextTheme: false
     },
     overrides = {},
     ...otherOptions
   } = options;


   const palette = createPalette(type, env, envTheme, undefined, paletteOption);

   const themeOverrides = deepmerge(overridesByComponentName, overrides, {
     clone: false
   });

   const muiThemeOverrides = deepmerge(
       {
         zIndex
       },
       otherOptions,
       {
         clone: false
       }
   );

   let unstableTheme = unstable_toolkit;
   const useNextTheme
       = unstable_toolkit
       && (unstable_toolkit.useNextTheme || unstable_toolkit.useNextDensity);
   if (useNextTheme) {
     unstableTheme = createToolkitThemeNext( {
       palette: { type },
         ...unstable_toolkit,
       zIndex: muiThemeOverrides.zIndex
     });
   }

   return createTheme({
     name: type,
     palette,
     shadows: shadowOption,
     unstable_toolkit: unstableTheme,
     typography: typographyOption,
     overrides: themeOverrides,
       ...muiThemeOverrides
   } as any);
 };

 export default createToolkitTheme;
